<modal-layout-right [modalTitle]="content?.title">
    <div modalBody>
        <p class="p1"
           *iCms="'copy' of content; content: 'html'"
           html></p>
    </div>
</modal-layout-right>